<template>
	<div
		class="grid grid-cols-1 md:grid-cols-3 justify-self-start gap-x-[40px] max-w-[345px] sm:max-w-[680px] md:max-w-[1420px] mx-auto"
	>
		<BaseCloudImage
			:class="status ? '-mt-10' : 'mt-3'"
			class="md:hidden w-dj-80"
			custom-class="rounded-normal overflow-hidden z-0"
			:public-id="logo"
			postfix=".jpg"
			alt="company logo"
			:transformation="[{ width: 80, height: 80, crop: 'scale' }]"
		/>
		<div class="md:col-span-2 flex flex-col">
			<CompanyProfileInfo
				class="mt-4 md:mt-9 mb-7"
				:name="name"
				:motto="motto"
				:tags="tags"
				:location="location"
				:company-badges="companyBadges"
			/>
			<DjBoxRte
				v-if="mission"
				class="hidden md:block"
				:title="$t('company.mission')"
				:copy="mission"
				without-margin
			></DjBoxRte>
		</div>

		<div class="mt-4 md:mt-9 flex flex-col justify-start">
			<CompanyProfileCard
				class="w-full md:w-auto md:ml-auto"
				:companySlug="companySlug"
				:companyId="companyId"
				:logo="logo"
				:name="name"
				:location="location"
				:jobs="jobs"
				:szmd="szmd"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "CompanyPageHeader",
	props: {
		logo: {
			type: String,
		},
		name: {
			type: String,
			default: "Company",
		},
		status: {
			type: Boolean,
			default: true,
		},
		mission: {
			type: String,
		},
		motto: {
			type: String,
		},
		location: {
			type: String,
		},
		tags: {
			type: Array,
		},
		jobs: {
			type: Number,
			default: 0,
		},
		companyId: {
			type: Number,
			required: true,
		},
		companySlug: {
			type: String,
			required: true,
		},
		companyBadges: {
			type: Array,
		},
		szmd: {
			type: Boolean,
			default: null,
		},
	},
	setup(_props) {
		const { locale } = useI18n();

		return {
			locale,
		};
	},
});
</script>
